<template>
	<div id="account">
		<layout>
			<div class="content-wrapper">
				<div class="box-account">
					<div class="account-sidebar">
						<ul>
							<li class="header-sidebar">ACCOUNT</li>
							<router-link to="/account/personal-detail" tag="li">Personal Detail</router-link>
							<router-link to="/account/business-detail" tag="li">Business Detail</router-link>
							<router-link to="/account/Users" tag="li">Users</router-link>
							<router-link to="/account/security" tag="li">Security</router-link>
						</ul>
						<ul>
							<li class="header-sidebar">CREDITS</li>
							<router-link to="/account/account-status" tag="li">Account status</router-link>
							<router-link to="/account/user-credit" tag="li">Add credits</router-link>
						</ul>
						<ul>
							<li class="header-sidebar">SETTINGS</li>
							<router-link to="/account/messaging-setting" tag="li">Messaging</router-link>
						</ul>
						<ul>
							<li class="header-sidebar">SUPPORT</li>
							<router-link to="/account/introductions" tag="li">Introductions</router-link>
							<router-link to="/account/contact-us" tag="li">Contact us</router-link>
						</ul>
					</div>
					<div class="account-view">
						<router-view />
					</div>
				</div>
			</div>
		</layout>
	</div>
</template>

<script>
import layout from '@/layouts/DefaultLayout';
export default {
	name: 'account',
	components: {
		layout,
	},
};
</script>

<style lang="scss" scoped>
#account {
	background-image: url('../assets/images/bg-dashboard.jpg');
	background-repeat: no-repeat;
	background-size: cover;
	background-attachment: fixed;

	.content {
		color: #58595b;

		a {
			color: #58595b;
		}

		.box-account {
			width: 100%;
			min-height: 100%;
			background-color: #fff;
			border: 1px solid #b9b9b9;
			display: flex;

			.account-sidebar {
				width: 25%;
				max-width: 312px;
				padding: 25px;
				border-right: 1px solid #b9b9b9;
				ul {
					list-style: none;
					padding: 0 0 60px;

					li {
						cursor: pointer;
						color: #58595b;
						&.router-link-active {
							font-weight: 600;
							color: var(--primary-color);
						}

						&.header-sidebar {
							margin-bottom: 8px;
							font-weight: 600;
						}
					}
				}
			}

			.account-view {
				width: 75%;
				padding: 25px;
			}
		}
	}

	@media only screen and (min-width: 1920px) {
		.content {
			color: #fff;
			font-size: 20px;

			.box-account {
				margin-top: 25px;
			}

			a {
				color: #58595b;
			}
		}
	}
}
</style>
